import './index.css'

import React from 'react'
import type { PlaylistTag } from 'types/playlist'
import type { NativeTag } from 'types/track'
import type { ColorIndicator } from '@disco/utils/color-indicators'
import { ACTIVE_COLORS, COLORS } from '@disco/utils/color-indicators'
import Icon from 'components/ui/icon'
import Label from 'components/ui/label'
import Tooltip from 'components/ui/tooltip'
type Props = {
  tooltip?: string
  used: Partial<Record<ColorIndicator, (NativeTag | PlaylistTag)[]>>
  value: ColorIndicator | null | undefined
  onChange: (color: ColorIndicator | null | undefined) => void
}

/**
 * Color indicator selection component for tagging system
 * Displays color swatches with usage information and selection state
 * @param tooltip - Optional tooltip text for the color selector
 * @param used - Map of colors to tags that are already using them
 * @param value - Currently selected color indicator
 * @param onChange - Callback when color selection changes
 */
const ColorIndicatorSelect = (props: Props): React.ReactNode => {
  return (
    <>
      <Label caption="Select a color" tooltipContent={props.tooltip} />
      <div className="color-indicator-select">
        {Object.keys(ACTIVE_COLORS).map((color: ColorIndicator) => (
          <label className="color-indicator-select-item" key={color}>
            <Tooltip
              content={
                props.used[color] ? (
                  <>
                    Used on:
                    <br />
                    {props.used[color].map(tag => tag.name).join(', ')}
                  </>
                ) : undefined
              }
            >
              <input
                className="color-indicator-select-input"
                name={color}
                type="radio"
                checked={props.value === color}
                onChange={() => props.onChange(color)}
              />
              <div
                className="color-indicator-select-background"
                style={{
                  background: COLORS[color],
                }}
              >
                <div className="color-indicator-select-icon">
                  <Icon type="check" />
                </div>
              </div>
            </Tooltip>
          </label>
        ))}
      </div>
    </>
  )
}

export default ColorIndicatorSelect
